<div class="m-t-10" *ngIf="transaction.total == 0">
    <a type="button" class="text-danger" (click)="onViewMessage(deleteTransactionModal)" 
        style="width: 150px;">
        <i class="fa fa-trash"></i>
            Eliminar
    </a>
</div>

<!-- confirm delete transaction-->
<ng-template #deleteTransactionModal let-modal>
    <div class="modal-body text-center">
        <p class="font-b2">¿Está seguro de que quiere eliminar esta transacción?</p>
        <p class="font-c1">Si la elimina, ya no podrá utilizar este Givi</p>
    </div>
    <div class="modal-footer">
        <div class="d-flex-center">
            <button class="btn btn-outline-primary btn-custom-modal mr-2" (click)="modal.dismiss()">Regresar</button>
            <button class="btn btn-primary btn-custom-modal" (click)="onDelete()">Eliminar</button>
        </div>
    </div>
</ng-template>